import { styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

export const ListingViewActionButtonsHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    z-index: 3;
    background-color: ${colors.white};
    box-shadow: 0 -3px 4px 1px rgb(0 0 0 / 15%);
    padding-top: 13px;
    padding-bottom: 13px;
    justify-content: center;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-top: 24px;
  }

  @media print {
    display: none;
  }
`;
